import { render, staticRenderFns } from "./VitalBox.vue?vue&type=template&id=9e40f974&scoped=true&lang=pug"
import script from "./VitalBox.vue?vue&type=script&lang=js"
export * from "./VitalBox.vue?vue&type=script&lang=js"
import style0 from "./VitalBox.vue?vue&type=style&index=0&id=9e40f974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e40f974",
  null
  
)

export default component.exports